import React, { useState} from 'react';
import {Input, Button, AgendaTextArea, AgendaLabel, ListOfAgendasText} from './styles/MeetingDetails-style';
import { Link } from 'react-router-dom';

function MeetingDetails() {
    const [meetingName, setMeetingName] = useState('');
    const [agenda, setAgenda] = useState('');
    const [agendaList, setAgendaList] = useState([]);
    const [error, setError] = useState(false)


    const handleMeetingNameChange = e => {
        setMeetingName(e.target.value);
    };

    function handleSubmitEnter() {
        setAgendaList(prevState => [...prevState, agenda]);
        setAgenda('');
    }


    const handleCreateMeeting = e => {
        
        if (((meetingName.trim().length !== 0) && !(agendaList.length !== 0)) 
            || (!(meetingName.trim().length !== 0) && (agendaList.length !== 0)) 
            || ((meetingName.trim().length === 0) && (agendaList.length === 0))) {
            setError(true);
            e.preventDefault();
        }

    };

    return (
        <div className="MeetingDetails">
            
            {error && (agenda.length <= 0 || meetingName.length<=0)?
            <label>Meeting Name or Agenda Cannot be Empty</label>:""}<hr></hr>
            <Input id="meetingName" name="meetingName" onChange={handleMeetingNameChange} placeholder="Enter Meeting Name" />
            <Button>
                <Link to="/meetingNotes" state={{meetingName:meetingName, agendaList:agendaList}} onClick={handleCreateMeeting} >Create Meeting</Link>
            </Button><hr></hr>
            <AgendaLabel>Agenda</AgendaLabel><hr></hr><hr></hr>
            <AgendaTextArea id="agenda" name="agenda" value={agenda} onChange={e => setAgenda(e.target.value)} placeholder='Enter Agenda Here' 
                onKeyDown={(ev) => {
                    if (ev.key === 'Enter') {
                        handleSubmitEnter(ev)
                    }
                }
            }/>
            <ListOfAgendasText>
                <ul>
                    {agendaList.map(agendaList => (
                        <li>{agendaList}</li>
                    ))}
                </ul>
            </ListOfAgendasText>
        </div>
    );
};

export default MeetingDetails;